import BaseService from '../../services/BaseService'
import { IAgendamento } from './AgendaType'

const authConfig = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  },
})

const agendaService = {
  getAll: async (pageNumber = 1, pageSize = 500): Promise<IAgendamento[]> => {
    const response = await BaseService.get(`/AgendamentoPsicomotricidade/ObterTodos?pageNumber=${pageNumber}&pageSize=${pageSize}`, authConfig())
    const data = response.data?.result || response.data
    return Array.isArray(data) ? data : []
  },

  getByProfessor: async (professorId: string): Promise<IAgendamento[]> => {
    const response = await BaseService.get(`/AgendamentoPsicomotricidade/ObterPorProfessor?professorId=${professorId}`, authConfig())
    const data = response.data?.result || response.data
    return Array.isArray(data) ? data : []
  },

  getByData: async (data: string): Promise<IAgendamento[]> => {
    const response = await BaseService.get(`/AgendamentoPsicomotricidade/ObterPorData?data=${data}`, authConfig())
    const data2 = response.data?.result || response.data
    return Array.isArray(data2) ? data2 : []
  },

  cadastrar: async (obj: Omit<IAgendamento, 'id' | 'professorNome' | 'clienteNome'>): Promise<IAgendamento> => {
    const response = await BaseService.post('/AgendamentoPsicomotricidade/Cadastrar', obj, authConfig())
    return response.data
  },

  atualizar: async (id: string, obj: Omit<IAgendamento, 'id' | 'professorNome' | 'clienteNome'>): Promise<IAgendamento> => {
    const response = await BaseService.put('/AgendamentoPsicomotricidade/Atualizar', { id, ...obj }, authConfig())
    return response.data
  },

  inativar: async (id: string): Promise<unknown> => {
    const response = await BaseService.delete(`/AgendamentoPsicomotricidade/ExcluirPorId?id=${id}`, authConfig())
    return response.data
  },
}

export default agendaService
